import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import { Alert } from "components/base/Toast";
import ImagesView from "components/shared/ImagesView";
import { useContext } from "react";
import { SAVE_PROJECT } from "../projects/graphql";
import { GTMProjectContext } from "./GTMProjectContext";

const GTMImagesView = () => {
  // Should save to the start up project.
  const { originalGTMProject } = useContext(GTMProjectContext);
  const [saveProject, saveProjectRes] = useMutation(SAVE_PROJECT, {
    onCompleted() {
      Alert("success", "Images saved.");
    },
    onError(error) {
      Alert("error", parseError(error));
    },
  });

  function onChangeHandler(newImages) {
    console.log("onChangeHandler", newImages);
    saveProject({
      variables: {
        id: originalGTMProject.startUpProject.id,
        images: newImages.join(","),
      },
    });
  }

  return (
    <ImagesView
      images={originalGTMProject.startUpProject.imageUrls}
      onChange={onChangeHandler}
      isLoading={saveProjectRes.loading}
    />
  );
};

export default GTMImagesView;
